import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import StarRating from "react-star-ratings";
import classes from "./coachAvailablityCard.module.css";
import { DropDown } from "../DropDown/DropDown.jsx";
import { Button } from "../Button/Button";
import moment from "moment";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { GetDaysBetweenDates } from "../../util/CustomFunctions";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";
import { ReactSVG } from "react-svg";
import {
  BackwardArrow,
  coachDemoImg,
  ForwardArrow,
} from "../../constant/imagePath";

export const CoachAvailablityCard = ({ userData }) => {
  const limit = 7;
  const [pageNo, setPageNo] = useState(1);
  const [dateArray, setDateArray] = useState([]);
  const [searchTimings, setSearchTimings] = useState([]);

  useEffect(() => {
    const dateList = GetDaysBetweenDates(
      moment(userData?.timing[0]?.date),
      moment(userData?.timing[userData?.timing.length - 1]?.date)
    );
    setDateArray(dateList);
  }, []);

  useEffect(() => {
    if (dateArray.length > 0) {
      HandleDateData(dateArray.slice(limit * (pageNo - 1), limit * pageNo));
    }
  }, [pageNo, dateArray]);

  const HandleDateData = (data) => {
    let newArray = data.slice();
    data.map((item, index) => {
      userData?.timing.map((innerItem, innerIndex) => {
        if (
          moment(item).format("YYYY-MM-DD") ==
          moment(innerItem?.date).format("YYYY-MM-DD")
        ) {
          newArray.splice(index, 1, innerItem);
        }
      });
    });
    setSearchTimings(newArray);
  };

  const [location, setLocation] = useState({
    label: "Riverbank State Park Tennis Courts",
    value: "Riverbank State Park Tennis Courts",
  });
  return (
    <>
      <style jsx>{`
        .${classes.dropdownLabel} {
          color: ${Colors.neutralShadesOfDimGray} !important;
        }
        .${classes.disabledArrowColor} path {
          stroke: ${Colors.neutralShadesOfPinkSwan};
        }
      `}</style>
      <div
        className={`${[classes.coachAvailablityCard].join(" ")}`}
        // style={{ boxShadow: `0px 4px 11px ${Colors.boxShadow}` }}
      >
        <Row className={`${[classes.card, "gx-0"].join(" ")}`}>
          <Col md={12} className={`${[classes.cardHeader].join(" ")}`}>
            <div>
              <img src={coachDemoImg} className={classes.cardImg} />
            </div>
            <div>
              <h3 className={`${[classes.name].join(" ")}`}>
                <span
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.h4,
                    fontSize: "26px",
                  }}
                >
                  {userData?.displayName?.split(" ")[0]}
                </span>
                <span
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.h4,
                    fontSize: "26px",
                  }}
                >
                  {userData?.displayName?.split(" ")[1]}
                </span>
              </h3>
              <div className={` ${[classes.details].join(" ")}`}>
                <span className={classes.starRating}>
                  <StarRating
                    starRatedColor={Colors.mainShadeOfRed}
                    starEmptyColor={Colors.neutralShadesOfGainsboro}
                    rating={1}
                    starDimension={"16px"}
                    numberOfStars={1}
                  />
                </span>

                <span
                  className={`${[classes.rating].join(" ")}`}
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.p2,
                    fontFamily: "inter-600",
                  }}
                >
                  {(userData?.rating).toFixed(1)}
                </span>
                <a
                  className={`${[classes.reviews].join(" ")}`}
                  style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p2 }}
                >
                  ({userData?.review.length} reviews)
                </a>
                <span
                  className={`${[classes.break].join(" ")}`}
                  style={{ backgroundColor: Colors.neutralShadesOfPinkSwan }}
                />

                <span
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.p2,
                    fontFamily: "inter-600",
                  }}
                >
                  {userData?.sport} coach
                </span>
                <span
                  className={`${[classes.break].join(" ")}`}
                  style={{ backgroundColor: Colors.neutralShadesOfPinkSwan }}
                />
                <span
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.p2,
                    fontFamily: "inter-600",
                  }}
                >
                  {userData?.city}
                </span>
              </div>
            </div>
          </Col>
          {/* Choose Location */}
          <Col md={12} className={classes.changeLocation}>
            <DropDown
              placeholder="Choose Location"
              label={"Choose Location"}
              state={location}
              setter={setLocation}
              labelClassName={classes.dropdownLabel}
              options={[
                {
                  label: "Riverbank State Park Tennis Courts",
                  value: "Riverbank State Park Tennis Courts",
                },
                {
                  label: "Riverbank Tennis Park",
                  value: "Riverbank Tennis Park",
                },
              ]}
            />
          </Col>
          {/* Select Time */}
          <Col md={12}>
            <div
              className={`${[classes.dateRangeBox].join(" ")}`}
              style={{ borderColor: Colors.neutralShadesOfGainsboro }}
            >
              <div className={`${[classes.timeRange].join(" ")}`}>
                <span
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.h7,
                    lineHeight: "24px",
                    fontFamily: "inter-600",
                  }}
                >
                  {moment(userData?.timing[0]?.date).format("MMM DD")}-
                </span>
                <span
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.h7,
                    lineHeight: "24px",
                    fontFamily: "inter-600",
                  }}
                >
                  {moment(
                    userData?.timing[userData?.timing.length - 1]?.date
                  ).format("MMM DD")}
                </span>
              </div>
              <div className={`${[classes.arrows].join(" ")}`}>
                <ReactSVG
                  src={BackwardArrow}
                  beforeInjection={(svg) => {
                    svg.classList.add(
                      classes.arrowLeft,
                      pageNo === 1 && classes.disabledArrowColor
                    );
                  }}
                  onClick={() =>
                    setPageNo((prev) => (prev > 1 ? prev - 1 : prev))
                  }
                />

                <ReactSVG
                  onClick={() =>
                    setPageNo((prev) =>
                      searchTimings?.length > 6 ? prev + 1 : prev
                    )
                  }
                  src={ForwardArrow}
                  beforeInjection={(svg) => {
                    svg.classList.add(
                      classes.arrowRight,
                      searchTimings?.length < 7 && classes.disabledArrowColor
                    );
                  }}
                />
              </div>
            </div>
          </Col>
          <Row className={["gx-0", classes.middleSectionScroll]}>
            {searchTimings?.map((item) => {
              return (
                <Col md={12}>
                  <div className={`${[classes.noAvailContainer].join(" ")}`}>
                    <h5
                      className={`${[classes.date].join(" ")}`}
                      style={{
                        color: Colors.neutralShadesOfNero,
                        ...Fonts.h7,
                        lineHeight: "24px",
                        fontFamily: "inter-600",
                      }}
                    >
                      {moment(
                        item?.time !== undefined ? item?.date : item
                      ).format("ddd, MMM DD")}
                    </h5>
                    {item?.time == undefined && (
                      <span
                        style={{
                          color: Colors.neutralShadesOfDimGray,
                          ...Fonts.p1,
                        }}
                      >
                        No Availability
                      </span>
                    )}
                  </div>
                  <div className={`${[classes.timings].join(" ")}`}>
                    {item?.time?.map((data) => {
                      return (
                        <span>
                          <Button
                            label={data}
                            primary={false}
                            customStyle={{
                              width: "93px",
                              padding: "0px",
                              height: "36px",
                              color: Colors.neutralShadesOfNero,
                              ...Fonts.p2,
                            }}
                          />
                        </span>
                      );
                    })}
                  </div>
                </Col>
              );
            })}
          </Row>
        </Row>
        <div
          className={`${[classes.btnsBorder].join(" ")}`}
          style={{ borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
        >
          <div className={`${[classes.btns].join(" ")}`}>
            <LinkButtonWithIcon
              text={"Cancel"}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
                marginRight: "48px",
              }}
              primary={false}
            />
            <Button
              primary={true}
              size={"Medium"}
              label={"Next"}
              customStyle={{ width: "120px", height: "48px" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

CoachAvailablityCard.defaultProps = {
  userData: {
    photo: coachDemoImg,
    displayName: "Michael Baumgardner",
    distance: "0.6 m away",
    city: "New York",
    lat: "",
    lng: "",
    aboutMe:
      "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis",
    price: 75,
    rating: 5,
    sport: "Tennis",
    timing: [
      {
        date: moment().format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(1, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(3, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(4, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(7, "days").format(),
        time: [],
      },
      {
        date: moment().add(8, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(9, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM1"],
      },
      {
        date: moment().add(10, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM1"],
      },
      {
        date: moment().add(12, "days").format(),
        time: [],
      },
      {
        date: moment().add(13, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM1"],
      },
      {
        date: moment().add(14, "days").format(),
        time: [],
      },
    ],
    review: [{}, {}, {}, {}, {}, {}, {}],
  },
};
